"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * iq.ts - Image Quantization Library
 */
var constants = require("./constants");
exports.constants = constants;
var conversion = require("./conversion");
exports.conversion = conversion;
var distance = require("./distance");
exports.distance = distance;
var palette = require("./palette");
exports.palette = palette;
var image = require("./image");
exports.image = image;
var quality = require("./quality");
exports.quality = quality;
var utils = require("./utils");
exports.utils = utils;
var helper_1 = require("./helper");
exports.buildPalette = helper_1.buildPalette;
exports.applyPalette = helper_1.applyPalette;
exports.buildPaletteSync = helper_1.buildPaletteSync;
exports.applyPaletteSync = helper_1.applyPaletteSync;
//# sourceMappingURL=image-q.js.map